// dependencies
import { List, Map, Record } from "immutable";
import moment from "moment";

// create a notification record
const NotificationRecord = Record({
	id: "",
	message: null,
	createdAt: null,
	timeToLive: 3500,
	type: "info",
	callback: () => {},
	clickAction: () => {},
});

const initialState = Map({
	active: List(),
});

export default function notifications(state = initialState, action) {
	switch (action.type) {
		case "NOTIFICATIONS:UNDO":
		case "NOTIFICATIONS:TOAST":
		case "NOTIFICATIONS:SUCCESS":
		case "NOTIFICATIONS:CHECKBOX": {
			const notification = new NotificationRecord({
				id: action.notificationId,
				type: action.notificationType,
				message: action.message,
				createdAt: moment(),
				timeToLive: action.ttl,
				callback: action.undoCallback,
				clickAction: action.clickAction,
			});
			return state.set("active", state.get("active").push(notification));
		}

		case "NOTIFICATIONS:ERROR": {
			const notification = new NotificationRecord({
				id: action.notificationId,
				type: action.notificationType,
				message: action.message,
				createdAt: moment(),
				timeToLive: action.ttl,
			});
			return state.set("active", state.get("active").push(notification));
		}

		case "NOTIFICATIONS:WARNING": {
			const notification = new NotificationRecord({
				id: action.notificationId,
				type: "warning",
				message: action.message,
				createdAt: moment(),
				timeToLive: action.ttl,
			});
			return state.set("active", state.get("active").push(notification));
		}

		case "NOTIFICATIONS:UPDATE": {
			return state.set("active", action.notifications);
		}

		default:
			// never forget your default return state!
			return state;
	}
}
